import React from "react";

function MainImg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            fill="none"
            viewBox="0 0 380 399"
        >
            <g clipPath="url(#clip0_0_6405)">
                <path
                    fill="url(#paint0_linear_0_6405)"
                    d="M43.787 324.958c7.758 8.121 15.098 13.357 20.893 17.495 68.166 48.629 148.82 34.455 165.959 30.992 25.314-5.112 74.24-14.991 109.618-56.359 53.521-62.582 51.233-165.531 3.673-226.258-6.703-8.556-47.061-75.552-129.228-88.573-49.142-7.79-106.849 6.522-148.5 41.216-87.421 72.829-81.2 219.952-22.42 281.487h.005z"
                ></path>
                <g opacity="0.92">
                    <path
                        fill="#7D97F4"
                        d="M282.596 1.373c-.674-1.887-3.434-1.612-3.718.372-2.728 19.203-11.463 69.325-31.329 97.952-32.352 46.609-48.597 117.467-19.707 149.199 0 0 128.422-41.781 54.754-247.523z"
                    ></path>
                    <path
                        fill="#fff"
                        d="M281.895 28.352c.009.482-.019 1.038-.032 1.566l-.074 1.603-.178 3.206a529.875 529.875 0 01-.431 6.407 594.847 594.847 0 01-1.11 12.795 659.225 659.225 0 01-2.944 25.514c-2.32 16.961-5.167 33.854-8.872 50.562-1.884 8.346-3.846 16.677-6.139 24.917-2.297 8.239-4.777 16.428-7.593 24.503a82.303 82.303 0 01-1.063 3.026l-1.096 3.013-1.096 3.013c-.38 1.001-.784 1.989-1.174 2.985-.797 1.985-1.549 3.987-2.388 5.953l-2.541 5.888c-3.484 7.808-7.345 15.446-11.632 22.854a.233.233 0 00.083.317.23.23 0 00.312-.078c4.493-7.308 8.468-14.927 12.104-22.698l2.618-5.879c.862-1.966 1.637-3.964 2.462-5.948.404-.996.821-1.984 1.211-2.981l1.132-3.012 1.137-3.013a87.23 87.23 0 001.101-3.023c5.708-16.189 10.256-32.77 13.924-49.533l1.344-6.293 1.247-6.31c.431-2.099.788-4.217 1.183-6.325l.577-3.164.537-3.174a547.811 547.811 0 003.773-25.449c1.059-8.51 1.986-17.035 2.692-25.582.348-4.271.655-8.552.912-12.828.119-2.14.239-4.28.33-6.425l.115-3.215.037-1.608c0-.542.022-1.06-.005-1.644a.23.23 0 00-.238-.216.224.224 0 00-.216.23v.05l-.009-.004z"
                        opacity="0.43"
                    ></path>
                </g>
                <path
                    fill="#91B3FA"
                    d="M345.771 23.408c-.376-2.324-3.622-2.6-4.37-.368-7.249 21.573-28.028 77.537-57.069 106.311-47.285 46.852-81.159 125.128-54.603 167.938 0 0 157.105-20.691 116.042-273.886v.005z"
                ></path>
                <path
                    fill="#fff"
                    d="M339.237 54.386c-.092.57-.238 1.2-.367 1.81l-.421 1.837-.881 3.665c-.6 2.44-1.224 4.873-1.857 7.303-1.279 4.86-2.618 9.7-4.002 14.532a791.795 791.795 0 01-8.826 28.82c-6.287 19.083-13.182 37.969-21.018 56.46-3.952 9.227-8.006 18.422-12.412 27.442a122.852 122.852 0 01-1.659 3.381l-1.692 3.362-1.692 3.362c-.573 1.116-1.169 2.218-1.756 3.329-1.183 2.214-2.334 4.446-3.544 6.642l-3.673 6.572c-.307.547-.605 1.098-.922 1.64l-.958 1.621-1.912 3.243-1.912 3.242c-.651 1.07-1.329 2.127-1.994 3.192l-2.004 3.188c-.678 1.056-1.316 2.14-2.026 3.169l-4.196 6.246c-5.703 8.258-11.797 16.24-18.34 23.855a.233.233 0 00.023.326.23.23 0 00.321-.018c6.726-7.482 12.934-15.423 18.776-23.616l4.268-6.228c.729-1.029 1.376-2.108 2.064-3.16l2.04-3.179c.674-1.06 1.366-2.112 2.031-3.182l1.949-3.234 1.948-3.233.977-1.617c.321-.542.623-1.093.94-1.639 10.032-17.458 18.812-35.618 26.63-54.164l2.893-6.972 2.787-7.013c.945-2.333 1.811-4.694 2.715-7.041l1.343-3.527 1.298-3.546c3.475-9.443 6.762-18.959 9.798-28.549 3.044-9.59 5.942-19.226 8.587-28.935a693.304 693.304 0 003.801-14.606 497.932 497.932 0 001.756-7.339l.83-3.683.395-1.847c.119-.624.256-1.217.348-1.892a.228.228 0 00-.192-.257.23.23 0 00-.257.188l-.009.05h.004z"
                    opacity="0.43"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M46.996 0h152.346c7.597 0 13.755 6.169 13.755 13.779v336.197c0 7.61-6.158 13.778-13.755 13.778H46.996c-7.596 0-13.755-6.168-13.755-13.778V13.779C33.241 6.169 39.4 0 46.996 0z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M63.988 0h152.346c7.597 0 13.755 6.169 13.755 13.779v336.197c0 7.61-6.158 13.778-13.755 13.778H63.988c-7.596 0-13.755-6.168-13.755-13.778V13.779C50.233 6.169 56.392 0 63.988 0z"
                ></path>
                <path
                    fill="#BDD0FB"
                    d="M67.537 3.6h143.996c6.584 0 11.921 5.347 11.921 11.942v181.404c0 6.596-5.337 11.942-11.921 11.942H67.537c-6.584 0-11.921-5.346-11.921-11.942V15.542c0-6.595 5.337-11.941 11.921-11.941zM67.954 211.138h143.997c6.583 0 11.921 5.347 11.921 11.942v125.132c0 6.595-5.338 11.942-11.921 11.942H67.954c-6.583 0-11.92-5.347-11.92-11.942V223.08c0-6.595 5.337-11.942 11.92-11.942z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M208.517 158.467a5.396 5.396 0 01-5.392-5.401V66.628a5.396 5.396 0 015.392-5.4c2.98 0 5.392 2.42 5.392 5.4v86.438a5.397 5.397 0 01-5.392 5.401zM209.415 288.124a5.397 5.397 0 01-5.392-5.402v-52.67a5.397 5.397 0 015.392-5.402 5.397 5.397 0 015.392 5.402v52.67a5.397 5.397 0 01-5.392 5.402z"
                ></path>
                <path
                    fill="url(#paint1_linear_0_6405)"
                    d="M333.987 273.271H199.881c-5.452 0-9.876 4.432-9.876 9.893v87.347h154.432v-86.778c0-5.777-4.682-10.467-10.45-10.467v.005z"
                ></path>
                <path
                    fill="url(#paint2_linear_0_6405)"
                    d="M232.017 284.969h103.891a3.98 3.98 0 013.976 3.982v70.027c0 2.2-1.78 3.982-3.976 3.982H232.017a3.978 3.978 0 01-3.975-3.982v-70.027a3.979 3.979 0 013.975-3.982z"
                ></path>
                <path
                    fill="url(#paint3_linear_0_6405)"
                    d="M222.838 273.271h-20.816c-6.635 0-12.022 5.397-12.022 12.042v85.198h32.838v-97.24z"
                ></path>
                <path
                    fill="url(#paint4_linear_0_6405)"
                    d="M230.476 351.239a2.446 2.446 0 002.44-2.443V302.55a2.447 2.447 0 00-2.44-2.443 2.45 2.45 0 00-2.439 2.443v46.246a2.449 2.449 0 002.439 2.443z"
                ></path>
                <path
                    fill="url(#paint5_linear_0_6405)"
                    d="M198.748 282.521h17.62a4.2 4.2 0 014.196 4.202v6.251a4.2 4.2 0 01-4.196 4.203h-17.62a4.2 4.2 0 01-4.195-4.203v-6.251a4.199 4.199 0 014.195-4.202z"
                    opacity="0.43"
                ></path>
                <path
                    fill="url(#paint6_linear_0_6405)"
                    d="M207.703 366.359c-5.353 0-9.693-4.347-9.693-9.709 0-5.363 4.34-9.71 9.693-9.71s9.692 4.347 9.692 9.71c0 5.362-4.339 9.709-9.692 9.709z"
                    opacity="0.47"
                ></path>
                <path
                    fill="url(#paint7_linear_0_6405)"
                    d="M207.556 364.379c-4.262 0-7.717-3.46-7.717-7.729s3.455-7.73 7.717-7.73 7.717 3.461 7.717 7.73-3.455 7.729-7.717 7.729z"
                    opacity="0.43"
                ></path>
                <g opacity="0.43">
                    <path
                        fill="url(#paint8_linear_0_6405)"
                        d="M209.55 307.8a2.87 2.87 0 002.866 2.871 2.87 2.87 0 002.866-2.871 2.87 2.87 0 00-2.866-2.871 2.87 2.87 0 00-2.866 2.871z"
                    ></path>
                    <path
                        fill="url(#paint9_linear_0_6405)"
                        d="M200.628 307.8a2.87 2.87 0 002.866 2.871 2.869 2.869 0 002.865-2.871 2.869 2.869 0 00-2.865-2.871 2.87 2.87 0 00-2.866 2.871z"
                    ></path>
                    <path
                        fill="url(#paint10_linear_0_6405)"
                        d="M209.55 317.734a2.87 2.87 0 002.866 2.871 2.87 2.87 0 002.866-2.871 2.87 2.87 0 00-2.866-2.87 2.87 2.87 0 00-2.866 2.87z"
                    ></path>
                    <path
                        fill="url(#paint11_linear_0_6405)"
                        d="M200.628 317.734a2.87 2.87 0 002.866 2.871 2.869 2.869 0 002.865-2.871 2.868 2.868 0 00-2.865-2.87 2.87 2.87 0 00-2.866 2.87z"
                    ></path>
                    <path
                        fill="url(#paint12_linear_0_6405)"
                        d="M209.39 328.316a2.87 2.87 0 002.866 2.871 2.87 2.87 0 002.865-2.871 2.869 2.869 0 00-2.865-2.87 2.87 2.87 0 00-2.866 2.87z"
                    ></path>
                    <path
                        fill="url(#paint13_linear_0_6405)"
                        d="M200.468 328.316a2.869 2.869 0 002.865 2.871 2.87 2.87 0 002.866-2.871 2.87 2.87 0 00-2.866-2.87 2.868 2.868 0 00-2.865 2.87z"
                    ></path>
                    <path
                        fill="url(#paint14_linear_0_6405)"
                        d="M208.909 338.577a2.868 2.868 0 002.865 2.87 2.87 2.87 0 002.866-2.87 2.87 2.87 0 00-2.866-2.871 2.869 2.869 0 00-2.865 2.871z"
                    ></path>
                    <path
                        fill="url(#paint15_linear_0_6405)"
                        d="M199.986 338.577a2.87 2.87 0 002.866 2.87 2.868 2.868 0 002.865-2.87 2.869 2.869 0 00-2.865-2.871 2.87 2.87 0 00-2.866 2.871z"
                    ></path>
                </g>
                <mask
                    id="mask0_0_6405"
                    style={{ maskType: "luminance" }}
                    width="112"
                    height="79"
                    x="228"
                    y="284"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#fff"
                        d="M228.042 284.969h111.842v77.991H228.042v-77.991z"
                    ></path>
                </mask>
                <g fill="#fff" mask="url(#mask0_0_6405)">
                    <path
                        d="M282.046 245.521l4.435-2.565 73.27 127.126-4.435 2.565-73.27-127.126z"
                        opacity="0.06"
                    ></path>
                    <path
                        d="M230.477 263.392l4.436-2.565 73.27 127.126-4.435 2.565-73.271-127.126z"
                        opacity="0.11"
                    ></path>
                    <path
                        d="M256.578 261.68l12.107-7.002 73.271 127.126-12.107 7.002-73.271-127.126z"
                        opacity="0.14"
                    ></path>
                </g>
                <path
                    fill="url(#paint16_linear_0_6405)"
                    d="M25.768 222.487c-1.674-4.45-2.394-9.746-1.293-15.923-6.75-1.176-13.045-3.587-18.574-7.427-.656 9.503 1.861 19.998 10.596 30.405 4.24 5.052 9.945 10.086 17.464 14.973l2.215 4.735 6.652-8.299S30.5 235.09 25.763 222.483l.005.004z"
                ></path>
                <path
                    fill="url(#paint17_linear_0_6405)"
                    d="M119.37 181.133c-6.822 1.199-12.792.303-18.065-1.658a32.185 32.185 0 01-.609 3.541c-1.151 5.195-2.742 10.228-4.966 14.867 10.22 1.516 19.45-1.456 26.332-5.001.096-4.809-1.215-8.805-2.687-11.749h-.005z"
                ></path>
                <path
                    fill="url(#paint18_linear_0_6405)"
                    d="M101.305 179.475c-8.862-3.293-15.758-9.594-21.425-14.063-11.935-9.411-20.995-4.552-20.995-4.552l13.003 24.636c8.125 7.666 16.254 11.262 23.842 12.383 2.224-4.639 3.815-9.673 4.966-14.867.275-1.19.472-2.366.609-3.542v.005z"
                ></path>
                <path
                    fill="url(#paint19_linear_0_6405)"
                    d="M144.923 169.274l-6.016 3.518c-7.203 4.754-13.682 7.317-19.537 8.341 1.472 2.944 2.783 6.94 2.687 11.748 7.634-3.931 12.375-8.565 12.375-8.565 13.613-8.8 10.486-15.042 10.486-15.042h.005z"
                ></path>
                <path
                    fill="url(#paint20_linear_0_6405)"
                    d="M76.744 339.715l49.087-206.467 21.008 4.06-31.137 209.935c-.068.469-.151.937-.238 1.401l-1.353 7.022c-2.32 12.052-10.779 20.549-18.89 18.983l-9.642-1.865c-8.11-1.566-12.806-12.607-10.481-24.659l1.352-7.023c.092-.463.188-.927.298-1.387h-.004zm16.153 21.036c5.382 1.042 11.159-5.47 12.911-14.546 1.747-9.071-1.197-17.274-6.58-18.312-5.382-1.038-11.16 5.47-12.91 14.546-1.748 9.071 1.196 17.274 6.579 18.312z"
                ></path>
                <path
                    fill="url(#paint21_linear_0_6405)"
                    d="M128.948 60.052l-7.849 40.747a9.531 9.531 0 002.21 8.111l10.013 11.349a9.505 9.505 0 0011.394 2.205l13.512-6.802a9.52 9.52 0 005.067-6.706l7.849-40.748c1.183-6.145 9.097-8.129 12.911-3.169 9.134 11.86 13.324 27.714 10.202 43.927-5.644 29.307-32.342 45.055-60.481 39.613-28.138-5.438-47.065-30.01-41.42-59.312 3.122-16.213 12.906-29.372 25.786-36.973 5.382-3.178 11.989 1.612 10.806 7.758z"
                ></path>
                <path
                    fill="url(#paint22_linear_0_6405)"
                    d="M132.781 60.791l-7.849 40.748a9.532 9.532 0 002.21 8.111l10.014 11.349a9.502 9.502 0 0011.393 2.204l13.512-6.802a9.521 9.521 0 005.067-6.705l7.849-40.748c1.183-6.145 9.097-8.13 12.912-3.174 9.133 11.86 13.324 27.714 10.201 43.926-5.644 29.307-32.342 45.056-60.481 39.614-28.138-5.438-47.065-30.01-41.42-59.312 3.122-16.213 12.906-29.372 25.786-36.973 5.382-3.178 11.989 1.612 10.806 7.757v.005z"
                ></path>
                <path
                    fill="url(#paint23_linear_0_6405)"
                    d="M79.802 340.308l49.087-206.468 21.008 4.06-31.136 209.935c-.069.469-.152.937-.239 1.401l-1.352 7.023c-2.32 12.051-10.78 20.548-18.89 18.982l-9.643-1.865c-8.11-1.566-12.806-12.607-10.481-24.659l1.352-7.022c.092-.464.188-.928.298-1.387h-.004zm16.153 21.035c5.383 1.043 11.16-5.47 12.911-14.546 1.747-9.075-1.197-17.273-6.579-18.311-5.383-1.043-11.16 5.47-12.912 14.545-1.747 9.071 1.197 17.274 6.58 18.312z"
                ></path>
                <path
                    fill="url(#paint24_linear_0_6405)"
                    d="M145.707 178.364a4.464 4.464 0 00-1.032-3.666c-1.687-1.956-4.608-4.638-6.726-2.833-3.155 2.691.302 11.9.302 11.9l3.494 5.346.051 3.412c1.889-2.218 3.021-7.674 3.911-14.164v.005z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M65.12 376.807c0-.147-.013-.294-.054-.441-2.37-8.712-13.416-13.962-13.416-13.962l-4.328.423c-2.348 7.766-1.94 12.492-1.5 14.591.014.06.033.115.046.17 3.586.253 10.95.322 19.248-.785l.005.004z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M45.868 377.593c.207.702.734 1.24 1.403 1.364 5.108.973 13.182-.042 16.57-.552.748-.11 1.284-.817 1.28-1.598-8.3 1.107-15.667 1.034-19.248.786h-.005z"
                ></path>
                <path
                    fill="url(#paint25_linear_0_6405)"
                    d="M45.456 356.387l2.003 8.823c.147.648.656 1.126 1.257 1.167.738.055 1.792.078 2.842-.101.945-.156 1.587-1.135 1.399-2.168l-1.426-7.84-6.08.115.005.004z"
                ></path>
                <path
                    fill="#91B3FA"
                    d="M83.905 376.784c-4.79-.046-7.28-.56-8.569-1.061.005.478.018.965.041 1.466.028.537.431.959.922.946l26.295-.666c.839-.023 1.311-1.006.931-1.769-3.444.349-12.215 1.158-19.62 1.089v-.005z"
                ></path>
                <path
                    fill="#7D97F4"
                    d="M103.525 375.696c-.032-.065-.06-.134-.11-.198-2.385-3.206-8.423-9.567-20.16-12.153l-5.613-.073s-2.416 4.395-2.31 12.447c1.288.5 3.778 1.019 8.569 1.061 7.41.068 16.176-.74 19.619-1.089l.005.005z"
                ></path>
                <path
                    fill="url(#paint26_linear_0_6405)"
                    d="M76.446 354.78c.068.418.958 6.765 1.302 9.227.082.583.513 1.029 1.05 1.084.958.096 2.503.17 3.851-.133.725-.166 1.243-.878 1.224-1.69l-.188-9.99-7.24 1.497v.005z"
                ></path>
                <path
                    fill="url(#paint27_linear_0_6405)"
                    d="M69.247 235.219s15.585 64.814 16.566 129.606c.018 1.18-9 2.223-9.207 1.134-2.104-11.106-15.992-83.425-22.384-93.497 0 0 .142 63.74 1.995 92.712.046.721-8.134 3.081-9.844 1.24 0 0-11.527-70.542-12-114.813-.022-2.278 4.086-16.387 4.086-16.387h30.793l-.005.005z"
                ></path>
                <path
                    fill="url(#paint28_linear_0_6405)"
                    d="M80.778 166.271c.253 2.517-.962-1.236 0 0z"
                ></path>
                <path
                    fill="url(#paint29_linear_0_6405)"
                    d="M80.778 166.271c-.023-.235-.06-.519-.11-.873-17.051-11.84-42.264-5.208-52.04-3.785a13.105 13.105 0 00-8.183 4.602c-4.98 5.999-13.53 18.285-14.54 32.927 5.525 3.839 11.82 6.251 18.574 7.426.564-3.16 1.6-6.549 3.237-10.173.188.841.418 1.667.688 2.48 7.345 21.862 11.178 34.346 11.238 38.562.009.574 33.645-.822 27.689-.997-2.49-.073 11.595-49.846 18.954-58.678.436-.524-6.465-12.727-5.502-11.491h-.005z"
                ></path>
                <path
                    fill="url(#paint30_linear_0_6405)"
                    d="M44.057 143.637l-1.416 18.022s10.16 2.857 17.409-2.475l-5.475-16.254-10.518.702v.005z"
                ></path>
                <path
                    fill="url(#paint31_linear_0_6405)"
                    d="M55.396 122.914c.248.225 10.637 19.745 10.637 19.745l-11.252 5.704-12.59-17.035s9.065-12.175 13.205-8.414z"
                ></path>
                <path
                    fill="url(#paint32_linear_0_6405)"
                    d="M51.613 127.089c-2.521.372-3.86 3.165-4.392 4.62a1.818 1.818 0 00.165 1.59l5.841 9.351c.087.142.193.271.317.381.687.615 3.026 2.402 4.763-.124 1.481-2.15 2.87-4.106 4.384-4.933a1.805 1.805 0 012.457.758c.968 1.837 2.847 5.576 4.049 9.135a1.809 1.809 0 01-1.009 2.237c-2.283.978-6.795 2.751-10.816 3.385a1.82 1.82 0 01-1.728-.698c-1.78-2.347-6.795-8.91-8.497-10.546-1.581-1.52-4.429-.881-5.712-.486a1.823 1.823 0 01-1.45-.161c-1.324-.763-3.644-2.687-1.618-6.053.505-.836.22-1.934-.605-2.458-1.481-.937-3.1-2.709-1.642-5.667 1.84-3.73 7.048-3.381 9.973-6.127 1.44-1.355 2.856-2.861 4.727-3.5.404-.138.82-.23 1.247-.22 1.839.036 4.626 3.072 4.75 4.909.179 2.618-3.012 4.281-5.208 4.602l.004.005z"
                ></path>
                <path
                    fill="url(#paint33_linear_0_6405)"
                    d="M49.348 145.69s-2.297-6.343-5.084-6.058c-2.784.285-4.93 3.114-1.413 6.173 4.374 3.812 6.497-.119 6.497-.119v.004z"
                ></path>
                <path
                    fill="url(#paint34_linear_0_6405)"
                    d="M26.758 194.765c-3.865-10.008-2.76-22.202-2.75-22.326l1.012.096c-.009.12-1.09 12.079 2.687 21.858l-.954.367.005.005z"
                ></path>
                <path
                    fill="url(#paint35_linear_0_6405)"
                    d="M53.7 271.162a.514.514 0 01-.5-.372c-1.202-4.313-9.693-8.915-9.776-8.961a.508.508 0 01-.206-.693.507.507 0 01.692-.207c.367.198 8.955 4.855 10.276 9.586a.508.508 0 01-.482.647H53.7z"
                ></path>
                <path
                    fill="url(#paint36_linear_0_6405)"
                    d="M29.495 202.761l12.55-18.941a.482.482 0 01.403-.216h22.975c.376 0 .725.197.917.524l10.922 18.513c.188.322.257.699.188 1.066-4.324 13.149-8.505 26.087-8.203 32.384-7.831 6.127-21.609 4.85-31.013 2.03-.486-8.216-4.52-21.145-8.9-34.538-.054-.285 0-.579.161-.822z"
                ></path>
                <path
                    fill="url(#paint37_linear_0_6405)"
                    d="M33.755 160.943l8.436 24.278h5.076l-7.501-25.284a.502.502 0 00-.578-.349l-5.282 1.093a.194.194 0 00-.147.257l-.004.005z"
                ></path>
                <path
                    fill="url(#paint38_linear_0_6405)"
                    d="M62.645 159.234l-2.073 25.316 4.686.574 3.99-25.242a.316.316 0 00-.285-.367l-5.997-.552a.294.294 0 00-.317.267l-.004.004z"
                ></path>
                <path
                    fill="url(#paint39_linear_0_6405)"
                    d="M61.824 124.163c-10.014-18.95-35.974-1.736-23.892 14.229 8.982-5.984 19.133-14.876 23.892-14.229z"
                ></path>
                <path
                    fill="url(#paint40_linear_0_6405)"
                    d="M61.168 122.119c20.248-1.033 3.581 6.486-14.86 10.5 4.59-4.882 9.18-8.52 14.86-10.5z"
                ></path>
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_0_6405"
                    x1="-47.689"
                    x2="288.093"
                    y1="489.86"
                    y2="73.556"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DAE3FE"></stop>
                    <stop offset="1" stopColor="#E9EFFD"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_0_6405"
                    x1="314.822"
                    x2="41.863"
                    y1="346.274"
                    y2="217.888"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_0_6405"
                    x1="239.912"
                    x2="334.236"
                    y1="239.918"
                    y2="419.269"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint3_linear_0_6405"
                    x1="271.641"
                    x2="170.349"
                    y1="203.235"
                    y2="393.883"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint4_linear_0_6405"
                    x1="263.232"
                    x2="217.507"
                    y1="263.814"
                    y2="349.879"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint5_linear_0_6405"
                    x1="184.847"
                    x2="272.348"
                    y1="314.437"
                    y2="220.019"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint6_linear_0_6405"
                    x1="147.68"
                    x2="230.529"
                    y1="426.222"
                    y2="330.519"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint7_linear_0_6405"
                    x1="162.637"
                    x2="228.607"
                    y1="408.719"
                    y2="332.511"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint8_linear_0_6405"
                    x1="228.376"
                    x2="184.673"
                    y1="268.605"
                    y2="375.575"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint9_linear_0_6405"
                    x1="220.724"
                    x2="177.02"
                    y1="265.477"
                    y2="372.447"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint10_linear_0_6405"
                    x1="231.843"
                    x2="188.139"
                    y1="270.019"
                    y2="376.994"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint11_linear_0_6405"
                    x1="224.195"
                    x2="180.486"
                    y1="266.896"
                    y2="373.866"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint12_linear_0_6405"
                    x1="235.401"
                    x2="191.697"
                    y1="271.471"
                    y2="378.446"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint13_linear_0_6405"
                    x1="227.748"
                    x2="184.044"
                    y1="268.347"
                    y2="375.318"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint14_linear_0_6405"
                    x1="238.569"
                    x2="194.865"
                    y1="272.77"
                    y2="379.741"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint15_linear_0_6405"
                    x1="230.921"
                    x2="187.213"
                    y1="269.643"
                    y2="376.613"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint16_linear_0_6405"
                    x1="32.077"
                    x2="21.877"
                    y1="144.409"
                    y2="244.144"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint17_linear_0_6405"
                    x1="110.072"
                    x2="99.008"
                    y1="183.82"
                    y2="291.996"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint18_linear_0_6405"
                    x1="1367.59"
                    x2="1327.14"
                    y1="-1818.13"
                    y2="-1755.73"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint19_linear_0_6405"
                    x1="163.512"
                    x2="79.462"
                    y1="135.694"
                    y2="247.324"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint20_linear_0_6405"
                    x1="1773.06"
                    x2="1741.82"
                    y1="-1895.78"
                    y2="-1855.42"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint21_linear_0_6405"
                    x1="1716.03"
                    x2="1684.78"
                    y1="-1939.94"
                    y2="-1899.58"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint22_linear_0_6405"
                    x1="133.506"
                    x2="-62.307"
                    y1="132.458"
                    y2="599.846"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint23_linear_0_6405"
                    x1="185.766"
                    x2="415.019"
                    y1="249.796"
                    y2="234.234"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint24_linear_0_6405"
                    x1="103.58"
                    x2="-10.674"
                    y1="161.076"
                    y2="97.861"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint25_linear_0_6405"
                    x1="50.377"
                    x2="47.241"
                    y1="347.674"
                    y2="380.439"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint26_linear_0_6405"
                    x1="80.905"
                    x2="77.769"
                    y1="350.598"
                    y2="383.358"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint27_linear_0_6405"
                    x1="107.602"
                    x2="36.778"
                    y1="135.877"
                    y2="390.172"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint28_linear_0_6405"
                    x1="80.65"
                    x2="80.406"
                    y1="166.124"
                    y2="168.503"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint29_linear_0_6405"
                    x1="1354.07"
                    x2="1313.62"
                    y1="-1826.88"
                    y2="-1764.48"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF928E"></stop>
                    <stop offset="1" stopColor="#FE7062"></stop>
                </linearGradient>
                <linearGradient
                    id="paint30_linear_0_6405"
                    x1="54.709"
                    x2="41.55"
                    y1="138.525"
                    y2="200.594"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint31_linear_0_6405"
                    x1="48.624"
                    x2="59.632"
                    y1="145.851"
                    y2="128.144"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint32_linear_0_6405"
                    x1="57.023"
                    x2="50.642"
                    y1="76.274"
                    y2="163.05"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#4F52FF"></stop>
                    <stop offset="1" stopColor="#4042E2"></stop>
                </linearGradient>
                <linearGradient
                    id="paint33_linear_0_6405"
                    x1="46.682"
                    x2="44.876"
                    y1="171.968"
                    y2="142.861"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FEBBBA"></stop>
                    <stop offset="1" stopColor="#FF928E"></stop>
                </linearGradient>
                <linearGradient
                    id="paint34_linear_0_6405"
                    x1="27.707"
                    x2="23.851"
                    y1="183.604"
                    y2="183.604"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E1473D"></stop>
                    <stop offset="1" stopColor="#E9605A"></stop>
                </linearGradient>
                <linearGradient
                    id="paint35_linear_0_6405"
                    x1="148.788"
                    x2="58.543"
                    y1="138.479"
                    y2="253.054"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint36_linear_0_6405"
                    x1="71.847"
                    x2="-3.759"
                    y1="143.899"
                    y2="396.807"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint37_linear_0_6405"
                    x1="51.04"
                    x2="-24.57"
                    y1="137.676"
                    y2="390.584"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint38_linear_0_6405"
                    x1="72.333"
                    x2="-3.277"
                    y1="144.041"
                    y2="396.95"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint39_linear_0_6405"
                    x1="31.682"
                    x2="109.485"
                    y1="110.66"
                    y2="196.598"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <linearGradient
                    id="paint40_linear_0_6405"
                    x1="70.598"
                    x2="45.633"
                    y1="124.458"
                    y2="128.762"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#09005D"></stop>
                    <stop offset="1" stopColor="#1A0F91"></stop>
                </linearGradient>
                <clipPath id="clip0_0_6405">
                    <path
                        fill="#fff"
                        d="M0 0H380V399H0z"
                        transform="matrix(-1 0 0 1 380 0)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default MainImg;
